import { useMutationBuilder } from "../useBuilders";
import { EXPERIENCES, STORYBOARDS, CREATE } from "../queryKeys";
import { experiencesImportDesignApi } from "src/services/experiences/importDesign";
import { CreatePPTStoryboardRequest } from "src/types/experiences/importDesign";

export const useImportPPTMutation = () =>
  useMutationBuilder(
    [EXPERIENCES, STORYBOARDS, CREATE, "ppt"],
    (request: CreatePPTStoryboardRequest) =>
      experiencesImportDesignApi.createStoryboardFromPPT(request),
    [EXPERIENCES, STORYBOARDS],
  );
